import React from "react"

const Carousel = ({ headerColor, textColor, bgImage }) => {
  return (
    <div
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center center",
        width: "100%",
        height: "280px",
        marginLeft: "-3px",
        textAlign: "-webkit-center",
        display: "flex",
        padding: "10px",
      }}
    >
      <div
        style={{
          width: "35px",
          height: "18px",
          backgroundColor: headerColor,
          borderRadius: "10px",
          color: "white",
          textAlign: "center",
          cursor: "pointer",
          minWidth: "fit-content",
          position: "absolute",
          right: "10px",
        }}
      >
        <span style={{ color: textColor }}>Open</span>
      </div>
      <div style={{ alignSelf: "end", color: "white", textAlign: "left" }}>
        <p style={{ margin: "0px" }}>Experience 1</p>
        <img
          src="https://admin.dev.markedprivate.com/app/images/preview/list_loader.png"
          style={{ width: "60%" }}
        />
      </div>
    </div>
  )
}

export default Carousel
